import api from "./api";

const userService = {
  // Get paginated users with filtering
  getUsers: async (page = 0, size = 10, filters = {}) => {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        size: size.toString(),
      });

      // Add filters to params
      Object.keys(filters).forEach((key) => {
        if (
          filters[key] !== null &&
          filters[key] !== undefined &&
          filters[key] !== ""
        ) {
          params.append(key, filters[key].toString());
        }
      });

      const response = await api.get(`/api/admin/users?${params}`);
      return response.data.data;
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }
  },

  // Get single user details by ID
  getUserDetails: async (id) => {
    try {
      const response = await api.get(`/api/admin/users/${id}`);
      return response.data.data;
    } catch (error) {
      console.error("Error fetching user details:", error);
      throw error;
    }
  },

  // Create new user
  createUser: async (userData) => {
    try {
      const response = await api.post("/api/admin/users", userData);
      return response.data.data;
    } catch (error) {
      console.error("Error creating user:", error);
      throw error;
    }
  },

  // Update existing user
  updateUser: async (id, userData) => {
    try {
      const response = await api.put(`/api/admin/users/${id}`, userData);
      return response.data.data;
    } catch (error) {
      console.error("Error updating user:", error);
      throw error;
    }
  },

  // Get filter options (we'll implement these if needed)
  getFilterOptions: async () => {
    try {
      // This would call multiple endpoints to get filter options
      const [campusResponse, universityResponse] = await Promise.all([
        api.get("/admin/campuses?page=0&size=1000"),
        api.get("/admin/universities?page=0&size=1000"),
      ]);

      return {
        campuses: campusResponse.data?.data?.data || [],
        universities: universityResponse.data?.data?.data || [],
      };
    } catch (error) {
      console.error("Error fetching filter options:", error);
      return { campuses: [], universities: [] };
    }
  },

  // Change user status and role
  changeUserStatusAndRole: async (userId, data) => {
    try {
      const response = await api.put(
        "/api/admin/users/change-status-and-role",
        {
          userId,
          emailVerified: data.emailVerified,
          isActive: data.active,
          isBanned: data.banned,
          role: data.role.toUpperCase(),
        }
      );
      return response.data.data;
    } catch (error) {
      console.error("Error changing user status and role:", error);
      throw error;
    }
  },

  // Get users with advanced filtering for club membership
  getUsersForClubMembership: async (
    campusId,
    page = 0,
    size = 20,
    search = ""
  ) => {
    try {
      const params = new URLSearchParams({
        campusId: campusId.toString(),
        isActive: "true",
        page: page.toString(),
        size: size.toString(),
      });

      if (search) params.append("search", search);

      const response = await api.get(`/api/admin/users?${params}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching users for club membership:", error);
      throw error;
    }
  },

  // Soft delete user account
  deleteUser: async (userId) => {
    try {
      const response = await api.delete(`/api/admin/users/${userId}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting user:", error);
      throw error;
    }
  },
};

export default userService;
